var map = {
	"./accessibleparking.png": 9388,
	"./accessibletoilet.png": 3987,
	"./atm.png": 5280,
	"./attraction.png": 614,
	"./babychanging.png": 131,
	"./bikerack.png": 8179,
	"./defibrillator.png": 5239,
	"./foodoutlet.png": 8178,
	"./offerholdersday.png": 1091,
	"./periodproduct.png": 277,
	"./prayerandreflection.png": 3878,
	"./repairs.png": 3118,
	"./retailoutlet.png": 4971,
	"./shower.png": 45,
	"./toilet.png": 7970,
	"./waterfountain.png": 7830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;